import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { ExternalLink, P, Span, URL } from 'shared';
function WizardFooter() {
    return (_jsxs("footer", { children: [_jsx("div", { className: "footer-container", children: _jsx(ExternalLink, { href: URL.PATIENT_SUPPORT, children: _jsx(Span, { variant: "body-medium", children: "PATIENT SUPPORT" }) }) }), _jsxs(P, { variant: "body-small", className: "copyright", children: ["Copyright @ ", new Date().getFullYear(), " Alphaeon Credit. All rights reserved."] })] }));
}
export default memo(WizardFooter);
